module.exports = __webpack_public_path__ + "img/intro-screen-bg-pink.07378319.png";